import { render, staticRenderFns } from "./PendingConsultRow.vue?vue&type=template&id=a35728d2&"
import script from "./PendingConsultRow.vue?vue&type=script&lang=js&"
export * from "./PendingConsultRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports